import { Reveal, Eyebrow } from "./Reveal";
import { MapPin } from "lucide-react";

const PORTRAIT =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_cabinet-juriste/artifacts/06cd0ce5cc2949d2_Image%202026-09-19%20at%2011.45.47.jpeg";

const CREDENTIALS = [
  "Juriste d'affaires",
  "Conformité bancaire",
  "Gestion des risques",
  "Conformité numérique",
];

export const Founder = () => (
  <section
    id="profil"
    data-testid="founder-section"
    className="relative overflow-hidden border-y border-ink-line bg-ink-card/30 py-24 lg:py-36"
  >
    <div
      aria-hidden="true"
      className="pointer-events-none absolute left-1/2 top-0 h-[40vh] w-[70vw] -translate-x-1/2 rounded-full bg-gold/5 blur-[140px]"
    />
    <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 lg:grid-cols-12 lg:px-12">
      <Reveal className="lg:col-span-5">
        <div className="relative mx-auto max-w-md">
          <div
            aria-hidden="true"
            className="absolute -inset-0 -translate-x-4 translate-y-4 border border-gold/40"
          />
          <div className="relative overflow-hidden border border-ink-line">
            <img
              src={PORTRAIT}
              alt="Armelle Mugobe Lehila, juriste d'affaires et conformité"
              data-testid="founder-photo"
              className="aspect-[4/5] w-full object-cover object-top"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent" />
          </div>
          <div
            data-testid="founder-badge"
            className="absolute -bottom-5 -right-4 border border-ink-line bg-ink px-5 py-4 shadow-2xl shadow-black/50 sm:-right-8"
          >
            <p className="font-serif text-lg text-ivory">Armelle Mugobe Lehila</p>
            <p className="mt-0.5 font-mono text-[10px] uppercase tracking-[0.24em] text-gold">
              Fondatrice — ALMALEX
            </p>
          </div>
        </div>
      </Reveal>

      <div className="lg:col-span-7 lg:pl-8">
        <Reveal>
          <Eyebrow>Votre interlocutrice</Eyebrow>
          <h2 className="mt-5 font-serif text-3xl font-medium leading-tight tracking-tight text-ivory sm:text-4xl lg:text-5xl">
            Le partenaire de confiance des{" "}
            <em className="italic text-gold">petites structures</em>
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-7 text-base leading-relaxed text-mute sm:text-lg">
            Armelle Mugobe Lehila est juriste d'affaires et de conformité. Son
            positionnement repose sur une expertise juridique complétée par une
            spécialisation en conformité bancaire, gestion des risques et
            conformité numérique.
          </p>
          <p className="mt-5 text-base leading-relaxed text-mute sm:text-lg">
            ALMALEX Legal Consulting propose un accompagnement accessible,
            personnalisé et adapté aux besoins des petites structures — pour
            transformer les obligations juridiques et réglementaires en outils
            de sécurisation et de développement.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <blockquote className="mt-9 border-l-2 border-gold pl-6">
            <p className="font-serif text-xl italic leading-relaxed text-ivory/90 sm:text-2xl">
              « Faire de la conformité un levier de sérénité et de performance,
              pas une contrainte. »
            </p>
          </blockquote>
        </Reveal>
        <Reveal delay={0.28}>
          <div className="mt-9 flex flex-wrap gap-2.5">
            {CREDENTIALS.map((c) => (
              <span
                key={c}
                className="border border-ink-line bg-ink px-4 py-2 font-mono text-[10px] uppercase tracking-[0.18em] text-ivory/80"
              >
                {c}
              </span>
            ))}
          </div>
          <p className="mt-7 flex items-center gap-2.5 text-sm text-mute">
            <MapPin className="h-4 w-4 text-gold" />
            138 avenue Victor Hugo, 75016 Paris — interventions en présentiel
            et à distance
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
